export type NewsCategory = "影视" | "生活" | "活动" | "绯闻";

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  publishedAt: string;
  source: string;
  cover: string;
  summary: string;
  heat: number;
  paragraphs: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "n001",
    title: "张柏芝时隔三年再登杂志封面，谈母亲与演员的双重身份",
    category: "影视",
    publishedAt: "2026-10-15",
    source: "明星资讯网 · 独家访谈",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20an%20elegant%20Asian%20woman%20in%20her%20forties%20wearing%20a%20cream%20silk%20blouse%2C%20standing%20in%20a%20minimal%20warm%20grey%20studio%20with%20soft%20window%20light%2C%20calm%20confident%20expression%2C%20film%20grain%2C%20muted%20beige%20and%20orange%20tones%2C%20high%20fashion%20magazine%20photography&width=1200&height=800&seq=cecilia-news-001&orientation=landscape",
    summary:
      "在最新一期杂志封面访谈中，张柏芝首次系统谈到近三年的生活节奏：把更多时间留给孩子，也把对角色的挑选变得更严苛。",
    heat: 9821,
    paragraphs: [
      "出道多年，张柏芝的名字始终与“镜头的宠儿”联系在一起。这一次，她以一张几乎没有修饰的封面回到公众视野：素色丝缎衬衫、散落的短发、略显疲惫却明亮的眼神。采访在午后进行，她提前一小时到达摄影棚，和摄影师讨论光线，也顺手帮着整理道具。",
      "“我以前很急，什么都想快一点。现在反而愿意等。”谈到近三年的节奏，她说自己把工作分成两半：一半是必须认真对待的角色，一半是必须亲自参与的孩子成长。她笑称这是“最难的两个剧本”，但也是最愿意反复打磨的两个。",
      "对于挑选角色的标准，她给出了非常具体的答案：故事要有真实的困境，人物不能只是漂亮的符号，团队要能接受她在片场反复提问。“我不想再演一个完美的人，我想演一个会被生活推到墙角、然后自己站起来的人。”",
      "访谈中她也提到对港产片的感情。她说自己仍然会重看九十年代的老电影，研究那些没有特效的镜头如何靠表演撑住。“那种戏是靠人和人之间真实的呼吸撑起来的，我希望还能参与这样的作品。”",
      "至于外界最关心的新项目，她只透露目前正在看两个剧本，其中一个与母女关系有关。“如果谈成，会是我这几年最想拍的一部。”",
    ],
  },
  {
    id: "n002",
    title: "新片《南方来信》首曝预告，张柏芝饰演独自经营旧书店的母亲",
    category: "影视",
    publishedAt: "2026-10-11",
    source: "明星资讯网 · 影视前线",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20small%20old%20bookshop%20with%20warm%20amber%20lamplight%2C%20wooden%20shelves%20full%20of%20used%20books%2C%20a%20woman%20in%20a%20knitted%20cardigan%20arranging%20books%20seen%20from%20behind%2C%20rainy%20window%2C%20muted%20brown%20and%20orange%20palette%2C%20nostalgic%20film%20texture&width=1200&height=800&seq=cecilia-news-002&orientation=landscape",
    summary:
      "《南方来信》公布首支预告，张柏芝在片中饰演一位守着一间旧书店的母亲，与久别归家的女儿重新学习相处。",
    heat: 8634,
    paragraphs: [
      "《南方来信》首支预告片在今天上午发布。两分零三秒的画面里，没有一句背景音乐的高潮，只有雨声、翻书声和一场没有说完的对话。",
      "张柏芝在片中饰演旧书店的经营者，一个习惯把事情藏在心里、把情绪收进抽屉的母亲。导演在采访中表示，选择她是因为“她脸上有故事，而且不怕安静”。",
      "预告片最后，母女两人坐在堆满旧书的柜台后分吃一碗面。这个镜头拍了十七条，最终选用的版本里，两人都没有看镜头。",
      "影片预计在明年春季上映，具体档期将在下月公布。",
    ],
  },
  {
    id: "n003",
    title: "品牌活动现身上海：一袭米白西装，谈女性如何与时间和解",
    category: "活动",
    publishedAt: "2026-10-08",
    source: "明星资讯网 · 活动现场",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20in%20a%20tailored%20ivory%20suit%20walking%20through%20a%20bright%20minimalist%20gallery%20space%20with%20warm%20wood%20floors%20and%20soft%20diffused%20light%2C%20paparazzi%20event%20photography%2C%20clean%20neutral%20palette%20with%20warm%20accents%2C%20graceful%20confident%20posture&width=1200&height=800&seq=cecilia-news-003&orientation=landscape",
    summary:
      "在上海的一场品牌活动上，张柏芝以米白色西装亮相。面对镜头她谈到“接受年龄”这件事，引发不少网友共鸣。",
    heat: 7412,
    paragraphs: [
      "活动在下午三点开始，张柏芝比预定时间早到了十五分钟。她在签到板前停下，配合不同角度的拍摄，全程笑意不多但很稳。",
      "被问到如何看待年龄，她的回答相当直接：“以前我总觉得要一直保持在最好的那个样子，现在我觉得，能让时间在自己身上留下痕迹，也是一种本事。”",
      "现场她被问到妆发秘诀，她说其实是“睡够”和“不折腾”。工作人员透露，她当天妆面不到二十分钟完成，只在唇色上做了两次调整。",
      "活动结束后她没有接受群访，直接前往机场，为下周的剧组定妆做准备。",
    ],
  },
  {
    id: "n004",
    title: "综艺《一屋三餐》官宣阵容，张柏芝将首次常驻生活类节目",
    category: "生活",
    publishedAt: "2026-10-02",
    source: "明星资讯网 · 综艺情报",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20open%20kitchen%20with%20wooden%20cabinets%20and%20terracotta%20ceramics%2C%20fresh%20vegetables%20on%20a%20marble%20counter%2C%20soft%20morning%20sunlight%20through%20linen%20curtains%2C%20homely%20editorial%20food%20photography%2C%20muted%20beige%20and%20orange%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=cecilia-news-004&orientation=landscape",
    summary:
      "生活类综艺《一屋三餐》公布常驻阵容，张柏芝将在一栋租来的老屋里买菜、做饭，与三位素人邻居共同生活十二天。",
    heat: 6908,
    paragraphs: [
      "节目组今天公布《一屋三餐》的常驻名单，张柏芝位列其中。这是她首次常驻生活观察类综艺。",
      "区别于常见的旅行或竞技形式，节目设定在一栋租来的老屋里，嘉宾需要自己买菜、做饭、打扫，并和住在附近的素人邻居相处。",
      "节目总导演表示，选她的原因很朴素：“她真的会做饭，而且不介意在镜头前把菜做坏。”",
      "节目预计于十一月开播，共十二期。",
    ],
  },
  {
    id: "n005",
    title: "旧作《忘不了》重映定档，胶片修复版保留原始色调",
    category: "影视",
    publishedAt: "2026-09-27",
    source: "明星资讯网 · 影史档案",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20street%20scene%20at%20dusk%20with%20neon%20reflections%20on%20wet%20pavement%2C%20old%20minibus%20passing%20by%2C%20warm%20amber%20lights%20mixed%20with%20cool%20shadows%2C%20nostalgic%20thirty-five%20millimeter%20film%20grain%2C%20cinematic%20composition&width=1200&height=800&seq=cecilia-news-005&orientation=landscape",
    summary:
      "《忘不了》将以胶片修复版本重映，片方确认保留原始色调与颗粒质感，新增幕后花絮片段。",
    heat: 5233,
    paragraphs: [
      "这部被视为张柏芝表演代表作之一的电影，将在下月以修复版本重回大银幕。",
      "修复团队表示，本次修复坚持“不美化”的原则：不去掉颗粒、不强行锐化、不改变原始色调，只做物理损伤的修补和声音的数字化还原。",
      "重映版本还会加映约八分钟的幕后片段，内容包括当年在街头实拍的记录和演员的现场采访。",
      "对于很多观众来说，这部片子是关于城市、关于告别，也是关于一个人如何在失去之后继续生活。",
    ],
  },
  {
    id: "n006",
    title: "公益活动走进乡村小学，为孩子们上第一堂表演课",
    category: "活动",
    publishedAt: "2026-09-19",
    source: "明星资讯网 · 公益记录",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20rural%20classroom%20with%20wooden%20desks%20and%20sunlight%20streaming%20through%20large%20windows%2C%20colorful%20children%20drawings%20on%20the%20wall%2C%20warm%20earthy%20palette%2C%20documentary%20photography%20style%2C%20gentle%20hopeful%20atmosphere&width=1200&height=800&seq=cecilia-news-006&orientation=landscape",
    summary:
      "在为期两天的公益行程中，张柏芝为乡村小学的孩子们带来了表演与朗读课，并捐赠了一批图书与教学设备。",
    heat: 4810,
    paragraphs: [
      "这次公益行程安排得很紧凑：上午是朗读课，下午是表演课，晚上和老师们坐下来聊课程资源。",
      "她说自己最怕的是“来一趟就走”，所以提前了解了学校的课程安排，把课堂内容设计成可以继续使用的教案。",
      "同行的志愿者提到，她在课堂上几乎没有明星的架子，蹲下来和孩子说话，也会认真听一个小学生讲完整的故事。",
      "此次捐赠包括图书、朗读设备和一批教学用品，后续的课程跟踪将由公益机构负责。",
    ],
  },
  {
    id: "n007",
    title: "回应外界传闻：希望把注意力放回作品本身",
    category: "绯闻",
    publishedAt: "2026-09-12",
    source: "明星资讯网 · 求证频道",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20portrait%20of%20an%20Asian%20woman%20seen%20through%20a%20slightly%20blurred%20window%20with%20rain%20drops%2C%20warm%20interior%20light%20behind%20her%2C%20muted%20sepia%20and%20soft%20orange%20tones%2C%20quiet%20melancholic%20documentary%20photography&width=1200&height=800&seq=cecilia-news-007&orientation=landscape",
    summary:
      "针对近期网络上的各种传闻，张柏芝工作室发布简短声明，希望公众把注意力放回作品与公益项目。",
    heat: 10233,
    paragraphs: [
      "工作室在本周发布一份不到两百字的声明，回应近期流传的多条不实信息。",
      "声明中没有针对具体传闻逐条反驳，只强调“相关说法无任何事实依据”，并请求媒体在转载前进行核实。",
      "随后张柏芝本人在社交平台更新了一张在剧组读剧本的照片，配文只有一句：“把时间花在值得的地方。”",
    ],
  },
  {
    id: "n008",
    title: "生活侧记：她的冰箱里有三样东西从不缺席",
    category: "生活",
    publishedAt: "2026-09-05",
    source: "明星资讯网 · 生活手记",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20home%20kitchen%20counter%20with%20a%20glass%20jug%20of%20lemon%20water%2C%20fresh%20herbs%20in%20a%20small%20vase%2C%20wooden%20cutting%20board%20and%20citrus%20fruits%2C%20soft%20natural%20morning%20light%2C%20warm%20neutral%20palette%2C%20lifestyle%20editorial%20photography&width=1200&height=800&seq=cecilia-news-008&orientation=landscape",
    summary:
      "在生活手记栏目的一次闲聊里，她聊到自己的冰箱：永远有柠檬、鸡蛋和一罐自制的辣椒酱。",
    heat: 3988,
    paragraphs: [
      "这段对话原本只是一次简短的电话沟通，最后聊了快一个小时。",
      "她提到自己做饭的原则是“不复杂”：主料两样，调味不超过三种，剩下的交给火候。冰箱里永远有三样东西：柠檬、鸡蛋、一罐自制辣椒酱。",
      "“孩子喜欢吃的东西不一定健康，但你可以把它做得健康一点。”她说自己现在最拿手的是一道番茄鸡蛋焖面，被家里的孩子评价为“可以开店的水平”。",
      "关于休息，她说自己最放松的方式是洗车和整理衣柜，因为这两件事“有明确的开始和结束”。",
    ],
  },
  {
    id: "n009",
    title: "品牌代言新签：成为某东方美学香氛亚太区代言人",
    category: "活动",
    publishedAt: "2026-08-28",
    source: "明星资讯网 · 商业观察",
    cover:
      "https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20on%20a%20beige%20stone%20pedestal%20surrounded%20by%20soft%20dry%20flowers%20and%20warm%20directional%20light%2C%20minimal%20oriental%20aesthetic%20still%20life%2C%20cream%20and%20amber%20palette%20with%20orange%20highlights%2C%20high%20end%20product%20photography&width=1200&height=800&seq=cecilia-news-009&orientation=landscape",
    summary:
      "品牌方宣布张柏芝成为亚太区代言人，首支形象短片以“慢下来的香气”为主题。",
    heat: 4421,
    paragraphs: [
      "品牌在今天发布的公告中确认这一合作，并同时上线首支形象短片。",
      "短片没有对白，只有她在窗前整理一束干花、在木桌上摊开手写信的片段。品牌方表示，选择她是因为“她的气质里有时间感”。",
      "据了解，这一合作将持续一年，后续还有线下快闪与限定礼盒计划。",
    ],
  },
  {
    id: "n010",
    title: "幕后：一场三分钟哭戏拍了整夜，她说这是这些年最难的一场",
    category: "影视",
    publishedAt: "2026-08-20",
    source: "明星资讯网 · 剧组手记",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20film%20set%20with%20a%20single%20warm%20practical%20lamp%2C%20camera%20rig%20silhouette%2C%20director%20chair%2C%20soft%20haze%20in%20the%20air%2C%20deep%20brown%20and%20amber%20tones%2C%20moody%20cinematic%20behind%20the%20scenes%20photography&width=1200&height=800&seq=cecilia-news-010&orientation=landscape",
    summary:
      "剧组人员回忆那场几乎没有台词的哭戏：从晚上八点拍到第二天凌晨四点，最终选了第一条。",
    heat: 6120,
    paragraphs: [
      "这场戏在剧本里只有两页，三分钟，几乎没有台词。",
      "执行导演说，那天晚上她要求在开拍前独自在场景里待了半小时，不要任何人打扰。开拍第一条，整组人没有一个人说话。",
      "“后来我们又拍了十几次，技术上都没问题，但导演最后用了第一条。”",
      "她本人在采访里只轻描淡写地说了一句：“那天我想起了一些不需要再提的事。”",
    ],
  },
  {
    id: "n011",
    title: "粉丝见面会门票十分钟售罄，主办方追加一场",
    category: "活动",
    publishedAt: "2026-08-12",
    source: "明星资讯网 · 粉丝现场",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20intimate%20theater%20venue%20with%20wooden%20seats%20and%20soft%20amber%20stage%20lighting%2C%20empty%20stage%20with%20a%20single%20microphone%20stand%2C%20curtains%20in%20muted%20terracotta%2C%20cozy%20cinematic%20photography&width=1200&height=800&seq=cecilia-news-011&orientation=landscape",
    summary:
      "原定一场的粉丝见面会在开票十分钟后售罄，主办方确认追加一场并调整入场安排。",
    heat: 5230,
    paragraphs: [
      "见面会定在一间只有四百个座位的小剧场，主办方原本没有追加计划。",
      "开票十分钟售罄后，社交平台上出现了大量求票信息，主办方当天下午宣布追加一场，并改为更严格的实名入场。",
      "据悉，见面会内容以读信和问答为主，不设商业环节。",
    ],
  },
  {
    id: "n012",
    title: "五十岁之后：她在采访里列了一份“不再做的事”清单",
    category: "生活",
    publishedAt: "2026-08-03",
    source: "明星资讯网 · 深度访谈",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20sunlit%20reading%20corner%20with%20a%20linen%20armchair%2C%20stack%20of%20books%20on%20a%20low%20wooden%20table%2C%20dried%20flowers%20in%20a%20ceramic%20vase%2C%20warm%20cream%20and%20soft%20orange%20tones%2C%20editorial%20interior%20photography&width=1200&height=800&seq=cecilia-news-012&orientation=landscape",
    summary:
      "在漫长的“不再做的事”清单背后，她谈的是如何把有限的精力留给真正重要的人和事。",
    heat: 4602,
    paragraphs: [
      "清单写在一张便利贴上，共十一条。她笑着承认自己没能全部做到，但写到第七条的时候“突然觉得轻松了”。",
      "“不再解释所有误解”“不再为了场合穿不舒服的鞋”“不再在凌晨回工作消息”——她说这些话并不新鲜，只是终于愿意承认自己也需要被照顾。",
      "谈到未来五年，她希望有两件事：拍一部自己真正喜欢的电影，以及把家里的院子种满植物。",
    ],
  },
];